module.exports = __webpack_public_path__ + "static/lock2-c628aa0d7719b20b2ee35e749e9996c3.png";